
import { defineComponent } from "vue";
import TrainingDocumentList from "@/components/TrainingDocumentList.vue";

export default defineComponent({
  name: "TrainingDocumentListScreen",
  components: {
    TrainingDocumentList,
  },
});
